module.exports = {"222405001":"安民街道","222405002":"龙门街道","222405100":"开山屯镇","222405102":"老头沟镇","222405103":"三合镇","222405104":"东盛涌镇","222405105":"智新镇","222405200":"德新乡","222405201":"白金乡","222405400":"龙井市林业局","222405401":"龙井大苏果树农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/222405.json
// module id = 668
// module chunks = 0